
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/find-my-classes",
      function () {
        return require("private-next-pages/find-my-classes/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/find-my-classes"])
      });
    }
  